export const CREATE_ADVERTISEMENT = 'CREATE_ADVERTISEMENT';
export const UPDATE_ADVERTISEMENT = 'UPDATE_ADVERTISEMENT';
export const FETCH_ADVERTISEMENTS = 'FETCH_ADVERTISEMENTS';
export const DELETE_ADVERTISEMENT = 'DELETE_ADVERTISEMENT';
